module.exports = __webpack_public_path__ + "img/20190708164850216.03013ae8.png";